var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C12.3247 0 10.6867 0.292833 9.13033 0.870333L9.53633 1.96408C10.9648 1.43449 12.4765 1.16444 14 1.16667C21.0764 1.16667 26.8333 6.92358 26.8333 14C26.8333 21.0764 21.0764 26.8333 14 26.8333C6.92358 26.8333 1.16667 21.0764 1.16667 14C1.16779 12.1092 1.58669 10.242 2.39343 8.53189C3.20017 6.82181 4.3748 5.31111 5.83333 4.10783V8.16667H7V2.33333H1.16667V3.5H4.74017C3.25057 4.81388 2.05752 6.42963 1.24026 8.23995C0.423003 10.0503 0.000223824 12.0138 0 14C0 21.7192 6.28075 28 14 28C21.7192 28 28 21.7192 28 14C28 6.28075 21.7192 0 14 0Z",
    fill: "#F35838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 18.6665H9.3335V19.8332H18.6668V18.6665H17.5002V16.675L14.825 13.9998L17.5002 11.3247V9.33317H18.6668V8.1665H9.3335V9.33317H10.5002V11.3247L13.1753 13.9998L10.5002 16.675V18.6665ZM11.6668 10.8417V9.33317H16.3335V10.8417L14.0002 13.175L11.6668 10.8417ZM14.0002 14.8247L16.3335 17.158V18.6665H11.6668V17.158L14.0002 14.8247ZM10.5002 22.1665H11.6668V23.3332H10.5002V22.1665ZM13.4168 22.1665H14.5835V23.3332H13.4168V22.1665ZM16.3335 22.1665H17.5002V23.3332H16.3335V22.1665Z",
    fill: "#F35838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingRed);
export default __webpack_public_path__ + "static/media/pendingRed.758be2f65c7c69be2961035b1bfc294e.svg";
export { ForwardRef as ReactComponent };